import { VOUCHERS_ROUTES } from '../../constants/_routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_voucher_request = () => {
  return {
    type: vouchersTypes.create.request
  }
}

const create_voucher_success = (response) => {
  return {
    type: vouchersTypes.create.success,
    payload: response.data.voucher
  }
}

const create_voucher_failure = (messages) => {
  return {
    type: vouchersTypes.create.failure,
    payload: messages
  }
}

const create_voucher = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_voucher_request())

    // Request
    axios.post(
      VOUCHERS_ROUTES.create,
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "A new voucher has been created and sent to the user")
      dispatch( create_voucher_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating voucher."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( create_voucher_failure(errors))
    })
  }

}

export {
  create_voucher
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/create.js